import React, { useState } from "react";
import alertError from "assets/icons/alertError.svg";
import axiosApi from "core/request";
import { useAppDispatch } from "hooks";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { RESET_PASSWORD_PATH } from "router/constants";
import ButtonWithProgress from "ui/ButtonWithProgress";
import ResetPassword from "views/ResetPassword";

import { ErrorMessage } from "@hookform/error-message";
import { Button, Menu, MenuItem } from "@mui/material";

import { langs } from "../../i18n";

import styles from "./ForgotPassword.module.scss";

const ForgotPassword = () => {
  const dispatch = useAppDispatch();
  const { t, i18n } = useTranslation();

  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm<{ email: string }>();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const isLanguageDropDownOpen = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const onSubmit = async (data: { email: string }) => {
    try {
      const response = await axiosApi.post("account/sendresetpasswordtoken", { email : data.email } );

      if (response.status === 204 ) {
        localStorage.setItem("resetEmail", data.email);
        // setIsPasswordSuccess(true);
        navigate(RESET_PASSWORD_PATH);
      }
    } catch (error) {
      setError("email", {
        type: "manual",
        message: "Не удалось отправить письмо. Проверьте email и попробуйте снова.",
      });
    }
  };

  return (
    <>
      <div className={styles.forgotPasswordContainer}>
        <div className={styles.forgotPasswordCentralBlock}>
          <div className={styles.forgotPasswordForm}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className={styles.loginFormInner}>
                <div className={styles.loginFormInnerTop}>
                  <h2 className={styles.forgotPasswordTitle}>
                    {t("forgotPassword.forgotYourPassword")}
                  </h2>
                  <Button
                    variant="text"
                    sx={{
                      textTransform: "capitalize",
                      fontSize: "1.1rem",
                      color: "#0b4d88",
                    }}
                    id="basic-button"
                    aria-controls={
                      isLanguageDropDownOpen ? "basic-menu" : undefined
                    }
                    aria-haspopup="true"
                    aria-expanded={isLanguageDropDownOpen ? "true" : undefined}
                    onClick={handleClick}
                  >
                    {t("loginForm.dropDownLabel")}
                  </Button>
                  <Menu
                    id="basic-menu"
                    sx={{
                      boxShadow: "0 4.8px 14.4px rgba(0,0,0,18)",
                    }}
                    anchorEl={anchorEl}
                    open={isLanguageDropDownOpen}
                    onClose={handleClose}
                  >
                    {langs.map((lng) => (
                      <MenuItem
                        key={lng}
                        onClick={() => {
                          i18n.changeLanguage(lng);
                          handleClose();
                        }}
                      >
                        {i18n.t(`languages.${lng}`)}
                      </MenuItem>
                    ))}
                  </Menu>
                </div>
                <span className={styles.forgotPasswordDescription}>
                  {t("forgotPassword.sendYouTheLink")}
                </span>
                <div
                  className={
                    errors.email
                      ? styles.loginFormInnerEmailContainer +
                        " " +
                        styles.loginFormInnerEmailContainerError
                      : styles.loginFormInnerEmailContainer
                  }
                >
                  <label htmlFor="email">
                    <span style={{ color: "grey" }}>E-mail</span>
                  <input
                    {...register("email", {
                      required: t("loginForm.requiredField") as string,
                      pattern: {
                        value: /^\S+@\S+$/i,
                        message: "Введите корректный email"
                      }
                    })}
                    type="email"
                    className={
                      errors.email
                        ? styles.loginFormInnerEmailInput +
                          " " +
                          styles.loginFormInnerEmailInputError
                        : styles.loginFormInnerEmailInput
                    }
                    placeholder={t("loginForm.enterEmail") as string}
                  />
                  </label>
                </div>
                <ErrorMessage
                  name="email"
                  errors={errors}
                  render={({ message }) => (
                    <span className={styles.loginFormInnerEmailInputErrorMsg}>
                      {message}
                    </span>
                  )}
                />
              </div>
              <div className={styles.loginFormInnerBottom}>
                <Button
                  type="submit"
                  variant="contained"
                  className={styles.resetPasswordButton}
                >
                  {t("forgotPassword.send")}
                </Button>
                <Button
                  variant="contained"
                  onClick={() => navigate(-1)}
                  className={styles.resetPasswordLink}
                >
                  {t("forgotPassword.goBack")}
                </Button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
